import { render, staticRenderFns } from "./Table.vue?vue&type=template&id=08e5c65d&scoped=true&"
import script from "./Table.vue?vue&type=script&lang=js&"
export * from "./Table.vue?vue&type=script&lang=js&"
import style0 from "./Table.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Table.vue?vue&type=style&index=1&id=08e5c65d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e5c65d",
  null
  
)

export default component.exports